<div class="notify-wrapper">

  <ng-container *ngFor="let n of notifications$ | async; index as index">

    <notify @notify-anim [notification]="n"></notify>

  </ng-container>
  
</div>
